<template>
<v-row class="im-result regular" no-gutters align="center">
    <v-col cols="12" md="3" class="px-1">
        <v-row no-gutters align="center">
            <v-avatar size="50" class="mx-2">
                <img v-if="item.avatar" :src="item.avatar">
                <v-icon v-else size="50">face</v-icon>
            </v-avatar>
            <div class="px-1">
                <div>{{item.name}}</div>
                <div v-if="$vuetify.breakpoint.smAndDown">{{item.type}}</div>
            </div>
        </v-row>
    </v-col>
    <v-col md="1" class="px-2" v-if="$vuetify.breakpoint.mdAndUp">
        <div>{{ item.type }}</div>
    </v-col>
    <v-col cols="12" md="3" class="px-2">
        <div>
            <div>{{ item.email }}</div>
            <div v-if="item.phone">{{ item.phone }}</div>
        </div>
    </v-col>
    <v-col cols="12" md="3" class="px-2">
        <div :class="{'pt-2': $vuetify.breakpoint.smAndDown}">
            <div v-if="item.contact">
                <div>{{ item.contact.name }}</div>
                <div>{{ item.contact.email }}</div>
                <div>{{ item.contact.phone }}</div>
            </div>
            <div class="font-weight-bold">No contact person added</div>
        </div>
    </v-col>
    <v-col md="2" class="px-2" v-if="$vuetify.breakpoint.mdAndUp">
        <div v-if="item.created_at">{{ item.created_at }}</div>
        <div v-else class="font-weight-bold">N/A</div>
    </v-col>
</v-row>
</template>
<script>
import defaults from "../../utils/PropDefaults.js"

export default {
    props: {
        item: {
            type: Object,
            default: defaults.user_item
        },
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },
    }
}
</script>
